import { css } from '@adornis/chemistry/directives/css.js';
import { xComponents } from '@adornis/chemistry/elements/x-components.js';
import type { Renderable } from '@adornis/chemistry/renderable.js';
import { XDropdownMultiSelection } from '@adornis/popover/x-dropdown-multiselection.js';
import { html, nothing, type TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { guard } from 'lit/directives/guard.js';
import { ref } from 'lit/directives/ref.js';
import './d-dropdown.js';
import './d-formfield-wrapper.js';
import './d-input.js';

/**
 * @element d-dropdown-multiselection
 */
@customElement('d-dropdown-multiselection')
export class DubniumDropdownMultiSelection<T> extends XDropdownMultiSelection<T> {
  @property({ attribute: false }) dropdownContentWrapperWidth: string | undefined;

  protected override _icon() {
    return 'caret-down';
  }

  protected override _search(): TemplateResult<1> | symbol {
    return this.search
      ? html`
          <d-flex ${css({ padding: this.spacing.sm, position: 'sticky', background: '#fff', top: '0' })}>
            <d-flex ${css({ position: 'relative' })}>
              <d-icon
                ${css({
                  position: 'absolute',
                  right: '16px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  zIndex: '10',
                  fontSize: '20px',
                  color: 'rgba(187, 187, 180, 1)',
                })}
              >
                magnifying-glass
              </d-icon>
              <d-input
                placeholder="Stichwortsuche"
                placeholder-mode="inline"
                @value-changed=${e => this._searchString.next(e.detail.value)}
                disable-blur-submit
                @mousedown=${() => (this._ignoreNextBlur = true)}
              ></d-input>
            </d-flex>
          </d-flex>
        `
      : nothing;
  }

  override renderItem: (x: T, index: number) => Renderable = (x: T, index: number) => html`
    <x-flex
      ${css({
        padding: `${this.spacing.sm} ${this.spacing.md}`,
        background: this.value.value?.includes(x) ? this.colors.accent.shade(200) : '#fff',
        cursor: 'pointer',
      })}
    >
      <d-text ${css({})}> ${this.renderString(x, index)} </d-text>
    </x-flex>
  `;

  override _dropdownContentWrapper() {
    return html`
      <x-dropdown-selection-content
        slot="dropdown-content"
        ${ref(dropdownContent => (this._dropdownContentElement = dropdownContent))}
        ${css({ width: this.dropdownContentWrapperWidth ?? (this._width ? this._width + 'px' : 'unset') })}
      >
        ${guard(this._guardTrigger(), () => xComponents(this._dropdownContent()))}
      </x-dropdown-selection-content>
    `;
  }
}
